import { Svg } from './svg'

export const StarIcon = () => (
  <Svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.61645 1.71446C7.13052 0.487106 8.86948 0.487106 9.38355 1.71446L10.8131 5.12772L14.5011 5.4326C15.8273
      5.54223 16.3646 7.19608 15.3562 8.06426L12.5518 10.4786L13.4015 14.0803C13.707 15.3754 12.3001 16.3976 11.1628
      15.7068L8 13.7857L4.83717 15.7068C3.69986 16.3976 2.29301 15.3754 2.59854 14.0803L3.44823 10.4786L0.643805
      8.06426C-0.364628 7.19608 0.172742 5.54223 1.49888 5.4326L5.18685 5.12772L6.61645 1.71446ZM8 3.58821L6.91426
      6.18048C6.69799 6.69683 6.2122 7.04978 5.65429 7.0959L2.85338 7.32745L4.98327 9.1611C5.40751 9.52634 5.59307
      10.0974 5.46453 10.6423L4.81921 13.3777L7.2213 11.9187C7.69976 11.628 8.30024 11.628 8.7787 11.9187L11.1808
      13.3777L10.5355 10.6423C10.4069 10.0974 10.5925 9.52635 11.0167 9.1611L13.1466 7.32745L10.3457 7.0959C9.78781
      7.04978 9.30201 6.69683 9.08574 6.18048L8 3.58821Z"
      fill="currentColor"
    />
  </Svg>
)
